import { combineReducers } from 'redux';

import userReducer from './User/userSlice';

export default combineReducers({
  user: userReducer,
});
